import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from '../infra/base-service';
import { ToastrService } from 'ngx-toastr';
import * as signalR from '@microsoft/signalr';
import { NotificationData, ResponseNegotiate } from '../interfaces/notificacao/signalr.interface';
import { environment } from '../environments/environment';
import { EnumNotificationType } from '../enums/notification.enum';

@Injectable({
  providedIn: 'root'
})

export class SignalRService extends BaseService {

  constructor(http: HttpClient, toastr: ToastrService) {
    super(http, toastr);
  }

  private hubConnection!: signalR.HubConnection;

  async negotiateConnection(token: string): Promise<void> {
    try {
      const response: ResponseNegotiate = await this.getExternal<ResponseNegotiate>(environment.urlSignalrNegotiate, { token: token});
      this.hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(response.url, {
          accessTokenFactory: () => response.accessToken,
        })
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Information)
        .build();

      await this.hubConnection.start();
      console.log('Conexão com SignalR iniciada.');
    } catch (error) {
      console.error('Erro ao negociar a conexão com SignalR:', error);
    }
  }

  novoEvento(callback: (data: NotificationData) => void): void {
    if (!this.hubConnection) {
        console.error('A conexão com SignalR não foi inicializada.');
        return;
      }

    this.hubConnection.on('novoEvento', (data: NotificationData) => {
        if(data.Success) {
            this.toastr.success(data.Message);
        }
        else{
            this.toastr.error(data.Message);
        }
        
        if(data.Type === EnumNotificationType.Payment) {
            callback(data);
        }
    });
  }

  stopConnection(): void {
    if (this.hubConnection) {
      this.hubConnection.stop().then(() => console.log('Conexão com SignalR encerrada.'));
    }
  }

  isConnectionLost(): boolean {
    return !this.hubConnection || this.hubConnection.state !== signalR.HubConnectionState.Connected;
  }
}


